// extracted by mini-css-extract-plugin
module.exports = {"AccordionFaq_container":"AccordionFaq_AccordionFaq_container__GjbVr","Accordion":"AccordionFaq_Accordion__QR9yc","AccordionFaq_header":"AccordionFaq_AccordionFaq_header__brUY_"};